import React, { useEffect, useState } from "react";
import Container from "common/components/Container/Container";
import "./index.less";
import { useDispatch, useSelector } from "react-redux";
import { rootReducerType } from "redux/combineReducers";
import AnalysisStation from "./components/AnalysisStation";
import ChartContainer from "./components/ChartContainer";
import {
  analysisApi,
  useGetActiveAnalysisQuery,
  useGetInactiveAnalysisQuery,
} from "services/analysisService";
import { emailToUsername } from "common/utils";
import { ReactComponent as MinusButton } from "assets/minus-button.svg";
import useWindowDimensions, { decodeJWT } from "common/functions";
import CustomiseAnalysis from "common/components/CustomiseAnalysis";
import InfoCard from "./components/InfoCard/InfoCard";
import { useSaveAnalysisMutation } from "services/analysisService";
import i18n from "internationalization/i18n";
import { Button } from "antd";
import Notification from "common/components/NotificationMessage/Notification";

type Props = {
  tabAnalysis: string;
  setTabAnalysis: (value: string) => void;
  shouldRefresh: boolean;
};

const Analysis: React.FC<Props> = ({
  tabAnalysis,
  setTabAnalysis,
  shouldRefresh,
}): React.ReactElement => {
  const [station, setStation] = useState<string>("all");
  const [expanded, setExpanded] = useState(false);
  // const [shouldRefresh, setShouldRefresh] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const { isLoggedIn } = useSelector(
    (state: rootReducerType) => state.authenticationReducer
  );
  const [saveAnalysis, { isSuccess }] = useSaveAnalysisMutation();

  const [params, setParams] = useState<any>({
    userName: emailToUsername(decodeJWT(isLoggedIn).email),
  });

  const { data: activeAnalysis, refetch: refetchActiveAnalysis } =
    useGetActiveAnalysisQuery(params);
  const { data: inactiveAnalysis, refetch: refetchInactiveAnalysis } =
    useGetInactiveAnalysisQuery(params);

  useEffect(() => {
    setActive(activeAnalysis);
    setInactive(inactiveAnalysis);
  }, [activeAnalysis, inactiveAnalysis]);

  const [active, setActive] = useState<any>(activeAnalysis);
  const [inactive, setInactive] = useState<any>(inactiveAnalysis);

  const [params1, setParams1] = useState<any>({
    userName: emailToUsername(decodeJWT(isLoggedIn).email),
    activeStats: active,
    inactiveStats: inactive,
  });

  let apiFunction: any = null;

  useEffect(() => {
    if (!expanded) {
      refetchActiveAnalysis();
      refetchInactiveAnalysis();
    }
  }, [expanded, refetchActiveAnalysis, refetchInactiveAnalysis]);

  useEffect(() => {
    if (expanded) {
      setActive(activeAnalysis);
      setInactive(inactiveAnalysis);
    }
  }, [expanded, activeAnalysis, inactiveAnalysis]);

  useEffect(() => {
    setParams({ userName: params.userName });
  }, [isLoggedIn]);

  useEffect(() => {
    setParams1({
      userName: emailToUsername(decodeJWT(isLoggedIn).email),
      activeStats: active,
      inactiveStats: inactive,
    });
    apiFunction && apiFunction();
  }, [active, inactive]);

  const handleClickItem = (stationName: string) => {
    setStation(stationName);
  };
  const removeAnalysis = (index: number) => {
    if (active && inactive) {
      setActive(active.filter((_, i) => i != index));
      setInactive([...inactive, active[index]]);
    }
  };

  const addAnalysis = (index: number) => {
    if (inactive) setInactive(inactive.filter((_, i) => i != index));
    if (active && inactive) setActive([...active, inactive[index]]);
  };

  useEffect(() => {
    if (isSuccess) {
      Notification({
        type: "success",
        message: i18n.t("analysis.toastTitle"),
        description: i18n.t("analysis.toastCustomisationSave"),
      });
      if (setExpanded) setExpanded(!expanded);
    }
  }, [isSuccess]);

  useEffect(() => {
    dispatch(
      analysisApi.endpoints.getActiveAnalysis.initiate(
        {
          userName: params.userName,
        },
        { subscribe: false, forceRefetch: true }
      )
    );
    dispatch(
      analysisApi.endpoints.getInactiveAnalysis.initiate(
        {
          userName: params.userName,
        },
        { subscribe: false, forceRefetch: true }
      )
    );
  }, [shouldRefresh, dispatch]);

  const desktopCards = () => (
    <>
      {expanded && active
        ? active.map((stat, index) => {
            return (
              <div className="summary-card-container">
                <div
                  className="action-image"
                  onClick={() => removeAnalysis(index)}
                >
                  <MinusButton fill="white" />
                </div>
                <InfoCard description={stat} simpleCard={true} />
              </div>
            );
          })
        : null}
    </>
  );

  const mobileCards = () => (
    <>
      {expanded && active ? (
        <>
          <Button
            size="small"
            onClick={() => {
              saveAnalysis(params1);
              // setShouldRefresh(!shouldRefresh);
              if (setExpanded) setExpanded(!expanded);
            }}
          >
            {i18n.t("analysis.save")}
          </Button>

          <div className="customise-stats-section">
            <div className="customise-active-stats-section">
              <h3>{i18n.t("analysis.activeAnalysis")}</h3>
              {active.map((stat, index) => {
                return (
                  <div
                    className="summary-card-container"
                    style={{
                      height: "12vh",
                      gap: "2vh",
                      width: "100%",
                    }}
                  >
                    <div
                      className="action-image"
                      onClick={() => removeAnalysis(index)}
                    >
                      <MinusButton fill="white" />
                    </div>
                    <InfoCard description={stat} simpleCard={true} />
                  </div>
                );
              })}
            </div>
            <div className="customise-inactive-stats-section">
              <h3>{i18n.t("analysis.inactiveAnalysis")}</h3>
              {inactive &&
                inactive.map((stat, index) => {
                  return (
                    <div
                      className="summary-card-container"
                      style={{
                        height: "12vh",
                        width: "100%",
                      }}
                    >
                      <div
                        className="action-image"
                        onClick={() => addAnalysis(index)}
                      >
                        <MinusButton fill="white" />
                      </div>
                      <InfoCard description={stat} simpleCard={true} />
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      ) : null}
    </>
  );

  const apiFun = (refrech) => {
    apiFunction = refrech;
  };

  return (
    <Container
      renderCondition={activeAnalysis || inactiveAnalysis ? true : false}
      loadingPageName="Analysis"
      backButton={false}
      editButton={false}
      childrenExpanded={
        <CustomiseAnalysis
          activeStats={active}
          inactiveStats={inactive}
          setInactiveStats={setInactive}
          setActiveStats={setActive}
          expanded={expanded}
          setExpanded={setExpanded}
          // setShouldRefresh={setShouldRefresh}
          shouldRefresh={shouldRefresh}
        />
      }
      setExpanded={setExpanded}
      expanded={expanded}
    >
      <div className="analysis-container">
        <AnalysisStation
          handleClickItem={handleClickItem}
          shouldRefresh={shouldRefresh}
        />
        {expanded ? (
          <div className="chartContainer">
            {width > 720 ? desktopCards() : mobileCards()}
          </div>
        ) : (
          <ChartContainer
            station={station}
            shouldRefresh={shouldRefresh}
            apiFun={apiFun}
          />
        )}
      </div>
    </Container>
  );
};

export default Analysis;
